class CartQuantityHandler {
  constructor() {
    document.addEventListener('cart:refresh', () => this.init());
    document.addEventListener('DOMContentLoaded', () => this.init());
    this.init();
  }

  init() {
    setTimeout(() => {
      this.setupQuantityHandlers();
    }, 100);
  }

  setupQuantityHandlers() {
    document.querySelectorAll('quantity-input').forEach(container => {
      const input = container.querySelector('.quantity__input');
      if (input && !input.dataset.hasQuantityHandler) {
        input.dataset.hasQuantityHandler = 'true';
        input.addEventListener('change', (e) => this.handleQuantityChange(e));
      }
    });
  }

  handleQuantityChange(event) {
    const input = event.target;
    const line = input.dataset.index;
    const quantity = parseInt(input.value);

    const loadingOverlay = input.closest('li')?.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    })
    .then(response => response.json())
    .then(data => {
      // Toplam fiyatı güncelle
      document.querySelectorAll('.cart-drawer__totals__row__money').forEach(el => {
        if (el) {
          el.textContent = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY'
          }).format(data.total_price / 100).replace('₺', '') + 'TL';
        }
      });

      // Ürün fiyatını güncelle
      const itemPrice = input.closest('li')?.querySelector('.regular-price');
      if (itemPrice && data.items[line - 1]) {
        itemPrice.textContent = new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: 'TRY'
        }).format(data.items[line - 1].final_line_price / 100).replace('₺', '') + 'TL';
      }

      // Cart bubble'ı güncelle
      const cartBubble = document.querySelector('.cart-count-bubble');
      if (cartBubble) {
        cartBubble.textContent = data.item_count;
      }

      if (loadingOverlay) loadingOverlay.classList.add('hidden');

      // Minus butonunun durumunu güncelle
      const minusButton = input.parentNode.querySelector('.quantity__button--minus');
      if (minusButton) {
        minusButton.classList.toggle('disabled', quantity <= 1);
      }

      this.setupQuantityHandlers();
    })
    .catch(error => {
      console.error('Error:', error);
      input.value = input.dataset.cartQuantity;
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
    });
  }
}

window.cartQuantityHandler = new CartQuantityHandler();